import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "more-box__val"
};
const _hoisted_2 = { class: "filt-box__main" };
const _hoisted_3 = { class: "filt-box__prices" };
const _hoisted_4 = { class: "f-price__prices-slider" };
const _hoisted_5 = { class: "f-price__main" };
const _hoisted_6 = { class: "f-price__range" };
const _hoisted_7 = { class: "filt-box__prices-range" };
const _hoisted_8 = { class: "filt-box__prices-start price-start" };
const _hoisted_9 = { class: "filt-box__prices-end price-end" };
import { computed, onBeforeUnmount, onMounted, ref, shallowRef, watch } from "vue";
import { create } from "nouislider";
import { format } from "../../../utils";
import ItemWrapper from "./ItemWrapper.vue";
const STEP = 100;
export default /*@__PURE__*/ _defineComponent({
    __name: 'RangeItem',
    props: {
        item: { type: Object, required: true },
    },
    emits: ["update"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const slider = shallowRef();
        const rangeElement = ref();
        const min = computed(() => Math.floor(props.item.available.min / STEP) * STEP);
        const max = computed(() => Math.max(Math.ceil(props.item.available.max / STEP) * STEP, min.value + STEP));
        const disabled = computed(() => props.item.available.min >= props.item.available.max);
        const formattedMin = ref(format(props.item.value.min ? props.item.value.min : min.value));
        const formattedMax = ref(format(props.item.value.max ? props.item.value.max : max.value));
        const formattedMinValue = computed(() => format(props.item.value.min));
        const formattedMaxValue = computed(() => format(props.item.value.max));
        const config = {
            start: [
                props.item.value.min ? props.item.value.min : min.value,
                props.item.value.max ? props.item.value.max : max.value,
            ],
            connect: true,
            step: STEP,
            range: {
                min: min.value,
                max: max.value,
            },
        };
        function toggleDisabled() {
            if (disabled.value) {
                slider.value?.disable();
            }
            else {
                slider.value?.enable();
            }
        }
        function reset() {
            props.item.value.min = 0;
            props.item.value.max = 0;
            slider.value?.reset();
            slider.value?.set([props.item.available.min, props.item.available.max]);
            emit('update', false);
        }
        watch([min, max], () => {
            slider.value?.updateOptions({
                range: {
                    min: min.value,
                    max: max.value,
                }
            }, true);
            if (!props.item.active) {
                slider.value?.set([min.value, max.value], true);
            }
        });
        watch(disabled, toggleDisabled);
        watch(() => props.item, () => {
            if (props.item.value.min || props.item.value.max) {
                slider.value?.set([props.item.value.min, props.item.value.max], true);
            }
            else {
                slider.value?.set([min.value, max.value], true);
            }
        });
        onMounted(() => {
            if (!rangeElement.value) {
                return;
            }
            slider.value = create(rangeElement.value, config);
            toggleDisabled();
            slider.value.on('change', (_values, _handle, unencoded) => {
                const selectedMin = Math.round(unencoded[0]);
                const selectedMax = Math.round(unencoded[1]);
                if (selectedMin !== min.value || selectedMax !== max.value) {
                    props.item.value.min = selectedMin;
                    props.item.value.max = selectedMax;
                    emit('update', true);
                }
                else {
                    props.item.value.min = 0;
                    props.item.value.max = 0;
                    emit('update', true);
                }
            });
            slider.value.on('update', (values) => {
                formattedMin.value = format(parseInt(String(values[0])));
                formattedMax.value = format(parseInt(String(values[1])));
            });
        });
        onBeforeUnmount(() => slider.value?.destroy());
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ItemWrapper, {
                item: __props.item,
                onReset: reset
            }, {
                badge: _withCtx(() => [
                    (__props.item.active)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(formattedMinValue.value) + " – " + _toDisplayString(formattedMaxValue.value), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ]),
                body: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("div", {
                                            ref_key: "rangeElement",
                                            ref: rangeElement
                                        }, null, 512 /* NEED_PATCH */)
                                    ])
                                ])
                            ]),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, _toDisplayString(formattedMin.value), 1 /* TEXT */),
                                _cache[0] || (_cache[0] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_9, _toDisplayString(formattedMax.value), 1 /* TEXT */)
                            ])
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["item"]));
        };
    }
});
